<template>
  <footer class="footer" id="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="footer-socials">
            <a :href="socials.facebook ? socials.facebook : '#'" target="_blank" class="social"><i class="fa fa-facebook"></i></a>
            <a :href="socials.twitter ? socials.twitter : '#'" target="_blank" class="social"><i class="fa fa-twitter"></i></a>
            <a :href="socials.instagram ? socials.instagram : '#'" target="_blank" class="social"><i class="fa fa-instagram"></i></a>
          </div>
          <a href="/" class="kf-footer-logo">
            <img src="../../assets/img/KF-logo-white.png" alt="Kungfood Logo" />
          </a>
          <div class="contacts">
            <div class="telephone"><span>Telephone:</span> {{ websiteContacts.phone }}</div>
            <div class="email"><span>Email:</span> {{ websiteContacts.email }}</div>
            <div class="address">{{ websiteContacts.address }}</div>
          </div>

          <router-link to="/contact" tag="button" class="find-us btn btn-danger btn-fill btn-secondary">
            Find us on map
          </router-link>
        </div>
      </div>
      <div class="copyright">
        {{ year }} Copyright &copy; Kungfood
      </div>
    </div>
  </footer>
</template>
<script>
  import { mapState } from 'vuex'

  export default {
    data () {
      return {
        year: (new Date()).getFullYear()
      }
    },
    computed: {
      ...mapState({
        websiteContacts: state => state.websiteContacts,
        socials: state => state.socials
      })
    }
  }

</script>



// WEBPACK FOOTER //
// ContentFooter.vue?3e8058cb